import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacyEn4() {
  return (
    <div>
      <Heading
        type={`h3`}
        title={
          <>
            {`IV.`}
            <br />
            {`Price of services and payment terms`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`The User is obliged to pay the price (fee) for the service according to the current price list of the Provider valid when ordering the service. The current price list is available at the individual service of the respective Instructor. Prices are in Eur. The Provider is not a VAT payer.`}</li>
            <li>{`The User acknowledges that payment for the services is paid through the payment gateway of GOPAY s.r.o., which provides secure technology for accepting payment cards and online bank transfers according to the international security standard PCI-DSS Level 1. More info at  https://www.gopay.com/.`}</li>
            <li>{`The Provider is entitled to change the price list by publishing a new price list. The price change does not affect already running Agreements concluded for the agreed period.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={4} className={sList}>
            <li>{`In the case of the option of automatic payment for the service for an indefinite period (i.e. deducting payment from the User's bank card or their account, if the selected payment system allows it), the User agrees to the automatic payment of agreed amounts by the Provider or operator of the relevant payment system at the appropriate interval without the need for personal authorization of payment by the User. The frequency of automatic payment corresponds to the selected payment period, while payment for the following period will always take place at the end of the relevant period. The User is entitled to change the method of payment in their User interface.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacyEn4;
